import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectComponent, NzSelectModule } from 'ng-zorro-antd/select';
import { ApiService } from '../../../Services/api.service';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { isBoolean } from 'lodash';

@Component({
  selector: 'app-add-amd-job-allocate',
  standalone: true,
  imports: [CommonModule, NzCollapseModule, NzIconModule, NzButtonModule, NzSelectModule, FormsModule, NzSwitchModule],
  templateUrl: './add-amd-job-allocate.component.html',
  styleUrl: './add-amd-job-allocate.component.scss'
})
export class AddAmdJobAllocateComponent {
  constructor(private apiService: ApiService) {

  }

  selectedProgram: string = '';
  locationList: any = [];
  jobCodeList: any = [];
  invalidForm: boolean = false;
  amdArrList: any = [
    { id: 1, fieldName: "Location", fieldType: "select", placeholder: "Select Location", value: '' },
    { id: 2, fieldName: "Job Code", fieldType: "select", placeholder: "Select Job Code", value: [], jobCodeList: [] },
    { id: 3, fieldName: "Display Custom Fields", fieldType: "toggle", value: false },
    { id: 4, fieldName: "Clear", fieldType: "button", value: '', actionIds: [1, 2, 3] }
  ];
  @Input() programList: any = [];
  repeatedLocation: boolean = false;
  @Output() emitData = new EventEmitter();
  selectedPairs: any = [];
  @ViewChildren('locationSelect') locationSelects!: QueryList<NzSelectComponent>;
  hasIncompleteRows = false;



  programValChange() {
    this.apiService.getLocationCode(this.selectedProgram).subscribe(res => {
      this.locationList = res;
      this.resetForm();
    })
  }

  locationValChange(locationData: any, index: number) {

    this.amdArrList[index + 1].value = [];

    this.apiService.getJobCode(this.selectedProgram, locationData.value).subscribe(res => {
      this.amdArrList[index + 1].jobCodeList = res.data.map((node: any) => Object.assign(node, { disabled: false }));

      if (this.selectedPairs.length != 0) {
        const jobCodeSet = new Set(
          this.selectedPairs
            .filter((node: any) => node.locationVal == locationData.value)
            .flatMap((node: any) => node.mappedJobCodes)
        );
        this.amdArrList[index + 1].jobCodeList.forEach((node: any) => {
          if (jobCodeSet.has(node.jobCode)) {
            node.disabled = true;
          }
        });
      }
    });
  }

  clearRow(data: any) {
    this.amdArrList.forEach((res: any, i: number) => {
      if (data.actionIds.includes(res.id)) {

        if (Array.isArray(res.value)) {

          if (res.value.length > 0) {
            const JobCodeSet = new Set(res.value.map((node: any) => node.jobCode));
            this.selectedPairs.forEach((node: any) => {
              if (node.locationVal === this.amdArrList[i - 1].value) {
                node.mappedJobCodes = node.mappedJobCodes.filter((child: any) =>
                  !JobCodeSet.has(child)
                );
              }
            });

            // Re-enable these job codes in any other row sharing the same location
            const clearedLocation = this.amdArrList[i - 1].value;
            this.amdArrList.forEach((otherRow: any, otherIdx: number) => {
              if (otherRow.placeholder === 'Select Job Code' && otherIdx !== i) {
                const otherRowLocation = this.amdArrList[otherIdx - 1]?.value;
                if (otherRowLocation === clearedLocation && Array.isArray(otherRow.jobCodeList)) {
                  otherRow.jobCodeList.forEach((jc: any) => {
                    if (JobCodeSet.has(jc.jobCode)) {
                      jc.disabled = false;
                    }
                  });
                }
              }
            });
          }

          res.value = [];
          res.jobCodeList = [];

          if (this.amdArrList[i - 1]) {
            this.amdArrList[i - 1].value = '';
          }
        }

        else if (typeof res.value === 'boolean') {
          res.value = false;
        }
      }
    });
  }

  addRow() {
    const lastId = this.amdArrList.length > 0
      ? this.amdArrList[this.amdArrList.length - 1].id
      : 0;

    this.amdArrList.push(
      { id: lastId + 1, fieldName: "Location", fieldType: "select", placeholder: "Select Location", value: '' },
      { id: lastId + 2, fieldName: "Job Code", fieldType: "select", placeholder: "Select Job Code", value: [], jobCodeList: [] },
      { id: lastId + 3, fieldName: "Toggle", fieldType: "toggle", value: false },
      { id: lastId + 4, fieldName: "Clear", fieldType: "button", value: '', placeholder: "", actionIds: [lastId + 1, lastId + 2, lastId + 3] }
    );
  }

  handleTabOnJobCode(event: Event, currentIndex: number) {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const totalRowsCount = this.amdArrList.length / 4;
    const currentRowIndex = Math.floor(currentIndex / 4);


    const isNextRowPresent = currentRowIndex < (totalRowsCount - 1);

    if (!isNextRowPresent) {

      this.addRow();
    }


    setTimeout(() => {

      const nextRowLocationIndex = currentRowIndex + 1;

      const selectComponents = this.locationSelects.toArray();

      if (selectComponents[nextRowLocationIndex]) {
        selectComponents[nextRowLocationIndex].focus();
      }
    }, 50);
  }



  validateForm() {

    this.amdArrList.forEach((res: any) => {
      res.hasError = false;
      res.errorMessage = '';
    });

    this.invalidForm = false;
    this.hasIncompleteRows = false;

    let totalValidPairs = 0;


    const isNodeValid = (node: any): boolean => {
      if (!node) return false;
      if (typeof node.value === 'string') {
        return node.value.trim().length > 0;
      }
      if (Array.isArray(node.value)) {
        return node.value.length > 0;
      }
      if (typeof node.value === 'boolean' && this.selectedProgram === 'AMD ALLOW') {
        return node.value === true;
      }
      return false;
    };


    if (this.selectedProgram === 'AMD' || this.selectedProgram === 'AMD ALLOW') {


      for (let i = 0; i < this.amdArrList.length; i += 2) {
        const locationNode = this.amdArrList[i];
        const jobCodeNode = this.amdArrList[i + 1];

        if (!locationNode || !jobCodeNode) continue;

        const isLocationValid = isNodeValid(locationNode);
        const isJobCodeValid = isNodeValid(jobCodeNode);


        if (isLocationValid && isJobCodeValid) {
          totalValidPairs++;
        }

        else if (isLocationValid || isJobCodeValid) {
          this.hasIncompleteRows = true;

          if (!isLocationValid) {
            locationNode.hasError = true;
            locationNode.errorMessage = 'Location is required to complete this pair.';
          }
          if (!isJobCodeValid) {
            jobCodeNode.hasError = true;
            jobCodeNode.errorMessage = 'Job Code is required to complete this pair.';
          }
        }

      }


      if (totalValidPairs === 0) {
        this.invalidForm = true;


        if (!this.hasIncompleteRows) {
          if (this.amdArrList[0]) {
            this.amdArrList[0].hasError = true;
            this.amdArrList[0].errorMessage = 'Minimum one valid pair is required.';
          }
          if (this.amdArrList[1]) {
            this.amdArrList[1].hasError = true;
            this.amdArrList[1].errorMessage = 'Minimum one valid pair is required.';
          }
        }
        return [];
      }
    }


    return this.amdArrList.filter((res: any) => isNodeValid(res));
  }

  saveRow() {

    const valid = this.validateForm();
    if (valid.length >= 2) {
      this.invalidForm = false;
      const data = this.createAmdJobCodePayload(valid);
      if (data && data.length > 0) {
        this.emitData.emit(data);
      }
    }
    else {
      this.invalidForm = true;
    }
  }

  resetForm() {

    this.selectedPairs = []
    this.invalidForm = false;
    this.hasIncompleteRows = false;

    this.amdArrList.forEach((res: any) => {
      res.jobCodeList = [];
      res.hasError = false;
      res.errorMessage = '';

      if (res && res.value !== undefined && res.value !== null) {

        if (typeof res.value === 'string') {
          res.value = '';
        }
        else if (typeof res.value === 'boolean') {
          res.value = false;
        }
        else if (Array.isArray(res.value)) {
          res.value = [];
        }

      }
    });
  }

  closeSelect(selectComponent: NzSelectComponent) {
    selectComponent.nzOpen = false;
  }

  createAmdJobCodePayload(data: any) {
    const addPayLoad: any = [];
    for (let i = 0; i <= data.length; i++) {
      const current = data[i];
      const next = data[i + 1];
      const toggle = data[i + 2];
      if (current && next && next.id === current.id + 1 && Array.isArray(next.value)) {
        next.value.forEach((job: any) => {
          addPayLoad.push({
            locationCode: current.value,
            jobCode: job.jobCode,
            description: job.description,
            dispCustomFields: toggle && toggle.fieldType == 'toggle' ? toggle.value ? 1 : 0 : 0,
            updateType: 'ADD'

          });
        });
        i++;
      }
    }
    return addPayLoad;
  }

pushPairs(evt: any, j: number) {

  const pairIndex = this.selectedPairs.findIndex((node: any) => node.locationVal === this.amdArrList[j - 1].value);
  if (pairIndex != -1) {
    this.selectedPairs[pairIndex].mappedJobCodes = [...this.selectedPairs[pairIndex].mappedJobCodes, ...evt.map((node: any) => node.jobCode)];
  }
  else {
    this.selectedPairs.push({ "locationVal": this.amdArrList[j - 1].value, "mappedJobCodes": [evt[0].jobCode] });
  }

  // Re-sync disabled state on any other row sharing the same location
  const currentLocation = this.amdArrList[j - 1].value;
  const currentJobCodeSet = new Set(evt.map((node: any) => node.jobCode));

  this.amdArrList.forEach((otherRow: any, otherIdx: number) => {
    if (otherRow.placeholder === 'Select Job Code' && otherIdx !== j) {
      const otherRowLocation = this.amdArrList[otherIdx - 1]?.value;
      if (otherRowLocation === currentLocation && Array.isArray(otherRow.jobCodeList)) {
        otherRow.jobCodeList.forEach((jc: any) => {
          if (currentJobCodeSet.has(jc.jobCode)) {
            jc.disabled = true;
          }
        });
      }
    }
  });
}


}